var _style, _desc, _g, _defs, _mask, _path, _defs2, _polygon, _path2, _path3, _polyline, _path4, _path5, _polyline2, _polygon2, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCmsGov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 41",
    style: {
      enableBackground: "new 0 0 171 41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{mask:url(#mask-2_00000181083692473065748320000005638640274782412213_);fill-rule:evenodd;clip-rule:evenodd;fill:#383838;}\n\t.st3{filter:url(#Adobe_OpacityMaskFilter_00000033340407793893668390000000898943378493981375_);}\n\t.st4{mask:url(#mask-2_00000109730938504462504710000004793253776933360276_);fill-rule:evenodd;clip-rule:evenodd;fill:#383838;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#383838;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#0d2499;}\n\t.st7{fill:none;stroke:#0d2499;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "CMSgov-Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(90.000000, 9.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0.8,
    y: 18.8,
    width: 5,
    height: 5.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.8,
    y: 18.8,
    width: 5,
    height: 5.1,
    id: "mask-2_00000181083692473065748320000005638640274782412213_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_00000174595355092566419560000002786709597218609550_",
    className: "st1",
    points: "0.8,0.4 31.8,0.4 31.8,31.9 0.8,31.9  "
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st2",
    d: "M3.3,18.8c0.7,0,1.3,0.2,1.8,0.7s0.7,1.1,0.7,1.8c0,0.7-0.2,1.3-0.7,1.8 c-0.5,0.5-1.1,0.7-1.8,0.7S2,23.6,1.5,23.1C1,22.6,0.8,22,0.8,21.3c0-0.7,0.2-1.3,0.7-1.8S2.6,18.8,3.3,18.8"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000158018136521635780700000008857142368500477862_",
    filterUnits: "userSpaceOnUse",
    x: 8.5,
    y: 0.4,
    width: 23.3,
    height: 31.6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 8.5,
    y: 0.4,
    width: 23.3,
    height: 31.6,
    id: "mask-2_00000109730938504462504710000004793253776933360276_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000158018136521635780700000008857142368500477862_)"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_00000049936832477608746580000016713505633821355909_",
    className: "st1",
    points: "0.8,0.4 31.8,0.4 31.8,31.9 0.8,31.9  "
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st4",
    d: "M20.5,3.1c-1.6,0-3.1,0.4-4.5,1.2c-1.4,0.8-2.5,1.9-3.3,3.3c-0.8,1.4-1.2,2.9-1.2,4.5 c0,2.4,0.8,4.5,2.5,6.1c1.6,1.6,3.8,2.4,6.4,2.4c2.6,0,4.8-0.8,6.4-2.4c1.6-1.6,2.4-3.7,2.4-6.3c0-1.7-0.4-3.2-1.1-4.5 c-0.7-1.3-1.8-2.4-3.1-3.1C23.5,3.5,22,3.1,20.5,3.1z M28.9,1h2.9v17.8c0,3.1-0.3,5.4-0.8,6.9c-0.8,2.1-2.1,3.6-3.9,4.7 C25.2,31.4,23,32,20.3,32c-1.9,0-3.6-0.3-5.2-0.8c-1.5-0.5-2.8-1.3-3.7-2.2s-1.8-2.2-2.6-4h3.1c0.8,1.5,1.9,2.6,3.3,3.3 c1.3,0.7,3,1.1,5,1.1c2,0,3.6-0.4,5-1.1c1.3-0.7,2.3-1.6,2.9-2.7c0.6-1.1,0.9-2.9,0.9-5.3V19c-1.1,1.4-2.4,2.4-4,3.1 c-1.6,0.7-3.2,1.1-5,1.1c-2.1,0-4-0.5-5.8-1.5c-1.8-1-3.2-2.4-4.2-4.1c-1-1.7-1.5-3.6-1.5-5.7c0-2.1,0.5-4,1.5-5.8 c1-1.8,2.4-3.2,4.3-4.2c1.8-1,3.7-1.6,5.7-1.6c1.7,0,3.2,0.3,4.7,1c1.4,0.7,2.8,1.8,4.2,3.4V1L28.9,1z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "st5",
    d: "M136.4,12.2c-2.4,0-4.4,0.9-6.2,2.6c-1.7,1.8-2.6,3.9-2.6,6.4c0,1.6,0.4,3.1,1.2,4.5 c0.8,1.4,1.8,2.5,3.2,3.2c1.3,0.8,2.8,1.1,4.4,1.1c1.6,0,3.1-0.4,4.4-1.1c1.3-0.8,2.4-1.8,3.2-3.2c0.8-1.4,1.2-2.9,1.2-4.5 c0-2.5-0.9-4.6-2.6-6.4C140.8,13.1,138.8,12.2,136.4,12.2z M136.4,9.4c3.4,0,6.3,1.2,8.5,3.7c2.1,2.3,3.1,5,3.1,8.1 c0,3.1-1.1,5.8-3.3,8.2s-5,3.5-8.4,3.5c-3.4,0-6.2-1.2-8.4-3.5c-2.2-2.3-3.3-5.1-3.3-8.2c0-3.1,1-5.8,3.1-8 C130.1,10.6,133,9.4,136.4,9.4L136.4,9.4z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-6",
    className: "st5",
    points: "149.1,10 152.2,10 159.7,26.2 167.1,10 170.2,10 159.9,32.3 159.4,32.3 149.1,10  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "st6",
    d: "M29.7,7.4l-4,3.8c-2.7-2.9-5.8-4.3-9.2-4.3c-2.9,0-5.3,1-7.3,3c-2,2-3,4.4-3,7.3 c0,2,0.4,3.8,1.3,5.4c0.9,1.6,2.1,2.8,3.7,3.7c1.6,0.9,3.4,1.3,5.3,1.3c1.7,0,3.2-0.3,4.6-0.9c1.4-0.6,2.9-1.8,4.5-3.4l3.9,4.1 c-2.2,2.2-4.3,3.7-6.3,4.5c-2,0.8-4.2,1.3-6.8,1.3c-4.7,0-8.5-1.5-11.5-4.5c-3-3-4.5-6.8-4.5-11.4c0-3,0.7-5.7,2-8 c1.4-2.3,3.3-4.2,5.8-5.6c2.5-1.4,5.3-2.1,8.2-2.1c2.5,0,4.9,0.5,7.2,1.6S28.1,5.5,29.7,7.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-8",
    className: "st7",
    d: "M29.7,7.4l-4,3.8c-2.7-2.9-5.8-4.3-9.2-4.3c-2.9,0-5.3,1-7.3,3c-2,2-3,4.4-3,7.3 c0,2,0.4,3.8,1.3,5.4c0.9,1.6,2.1,2.8,3.7,3.7c1.6,0.9,3.4,1.3,5.3,1.3c1.7,0,3.2-0.3,4.6-0.9c1.4-0.6,2.9-1.8,4.5-3.4l3.9,4.1 c-2.2,2.2-4.3,3.7-6.3,4.5c-2,0.8-4.2,1.3-6.8,1.3c-4.7,0-8.5-1.5-11.5-4.5c-3-3-4.5-6.8-4.5-11.4c0-3,0.7-5.7,2-8 c1.4-2.3,3.3-4.2,5.8-5.6c2.5-1.4,5.3-2.1,8.2-2.1c2.5,0,4.9,0.5,7.2,1.6S28.1,5.5,29.7,7.4z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-10",
    className: "st6",
    points: "37.7,2.1 43.3,2.1 50.3,23.2 57.3,2.1 62.9,2.1 68,32.3 62.4,32.3 59.2,13.2 52.8,32.3 47.7,32.3 41.4,13.2 38,32.3 32.5,32.3 37.7,2.1  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-11",
    className: "st7",
    points: "37.7,2.1 43.3,2.1 50.3,23.2 57.3,2.1 62.9,2.1 68,32.3 62.4,32.3 59.2,13.2 52.8,32.3 47.7,32.3 41.4,13.2 38,32.3 32.5,32.3  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "st6",
    d: "M88.4,6.2L84.1,10c-1.5-2.1-3-3.1-4.6-3.1c-0.8,0-1.4,0.2-1.8,0.6C77.2,7.9,77,8.3,77,8.8 c0,0.5,0.2,1,0.5,1.4c0.5,0.6,1.9,1.9,4.2,3.9c2.2,1.8,3.5,3,4,3.5c1.2,1.2,2,2.3,2.5,3.4c0.5,1.1,0.7,2.2,0.7,3.5 c0,2.5-0.9,4.5-2.6,6.1s-3.9,2.4-6.7,2.4c-2.1,0-4-0.5-5.6-1.6c-1.6-1.1-3-2.7-4.1-5l4.8-2.9c1.5,2.7,3.1,4,5,4 c1,0,1.8-0.3,2.5-0.9c0.7-0.6,1-1.2,1-2c0-0.7-0.3-1.4-0.8-2C82,22,80.9,21,79.2,19.6c-3.3-2.7-5.4-4.7-6.4-6.2 c-1-1.5-1.4-2.9-1.4-4.4c0-2.1,0.8-3.9,2.4-5.4c1.6-1.5,3.6-2.2,5.9-2.2c1.5,0,2.9,0.3,4.3,1C85.3,3.1,86.8,4.4,88.4,6.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-14",
    className: "st7",
    d: "M88.4,6.2L84.1,10c-1.5-2.1-3-3.1-4.6-3.1c-0.8,0-1.4,0.2-1.8,0.6C77.2,7.9,77,8.3,77,8.8 c0,0.5,0.2,1,0.5,1.4c0.5,0.6,1.9,1.9,4.2,3.9c2.2,1.8,3.5,3,4,3.5c1.2,1.2,2,2.3,2.5,3.4c0.5,1.1,0.7,2.2,0.7,3.5 c0,2.5-0.9,4.5-2.6,6.1s-3.9,2.4-6.7,2.4c-2.1,0-4-0.5-5.6-1.6c-1.6-1.1-3-2.7-4.1-5l4.8-2.9c1.5,2.7,3.1,4,5,4 c1,0,1.8-0.3,2.5-0.9c0.7-0.6,1-1.2,1-2c0-0.7-0.3-1.4-0.8-2C82,22,80.9,21,79.2,19.6c-3.3-2.7-5.4-4.7-6.4-6.2 c-1-1.5-1.4-2.9-1.4-4.4c0-2.1,0.8-3.9,2.4-5.4c1.6-1.5,3.6-2.2,5.9-2.2c1.5,0,2.9,0.3,4.3,1C85.3,3.1,86.8,4.4,88.4,6.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmsGov);
export default __webpack_public_path__ + "static/media/cms-gov.39bb918db3f784b7702374b552956469.svg";
export { ForwardRef as ReactComponent };